export enum ManagedDocumentsType {
    NONE=0,
    TEXT=1,
    DATETIME=2
}